import { Container as PixiContainer } from 'pixi.js'
import { useEffect, useRef } from 'react'
import { Container } from '@pixi/react'
import { tableService } from '../domain/table/tableService'

/**
 * collectCombo 飛行動畫的獨立容器，不受 spin 週期的 _upperContainer/upperContainer2
 * destroyChildren 影響（見 tableService.collectCombo 的註解）。
 */
export const CollectLayer = () => {
  const collectLayerRef = useRef<PixiContainer>(null)
  useEffect(() => {
    if (collectLayerRef.current) {
      tableService.setCollectLayer(collectLayerRef.current)
    }
  }, [])
  return (
    <Container
      name="CollectLayer"
      x={0}
      y={0}
      ref={collectLayerRef}
    >
    </Container>
  )
}
